import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    /*
     load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
     learn more: https://github.com/i18next/i18next-http-backend
    */
    .use(Backend)
    /*
        自瀏覽器設定取得使用者的語言並優先套用
    */
    .use(LanguageDetector)
    /*
     pass the i18n instance to react-i18next.
    */
    .use(initReactI18next)
    /*
     init i18next
     for all options read: https://www.i18next.com/overview/configuration-options
    */

    .init({
        fallbackLng: 'zh_Hant',
        interpolation: {
            // 是否要讓字詞 escaped 來防止 xss 攻擊，這裡因為 React.js 已經做了，就設成 false即可
            escapeValue: false,
        },
        backend: {
            loadPath: (lngs: string[], namespaces: string[]) => `/assets/i18n/{{lng}}/{{ns}}.json?t=${Date.now()}`
        },
        nonExplicitSupportedLngs: true,
        load: 'all',
        ns: [
            'activity',
            'boat',
            'common',
            'config',
            'dealersDen',
            'email',
            'form',
            'fursuiter',
            'hotel',
            'notification',
            'payment',
            'point',
            'registration',
            'sms',
            'user',
            'lottery',
            'punch'
        ],
    })

export default i18n;